import { useContext } from 'react';
import { UserState } from './authUtils';
import { claimsKeys } from './claims';
import useBaseQuery from './baseQuery';
import { ClaimPhotosType } from '../graphql/GetClaimPhotosList';
import { DomainParams } from './graphQLClientUtil';
import NetworkContext from '../contexts/NetworkContext';
import { PagedClaimPhotosType } from '../graphql/GetClaimPhotosListPaged';
import GET_CLAIM_VIDEOS_LIST_PAGED from '../graphql/GetClaimVideosListPaged';

const useClaimVideosPaged = (
  region: number,
  claimIndx: number,
  currentPage: number,
  itemsPerPage: number,
  userState: UserState,
  videosList?: ClaimPhotosType[],
  setVideosList?: (_levelsList: ClaimPhotosType[]) => void,
  setTotalItems?: (totalItems: number) => void,
  onSuccess?: (_data: any, claimIndx: number) => Promise<void>,
) => {
  const network = useContext(NetworkContext);
  const enabled = network.connected && !!claimIndx;

  const onSuccessPhotos = async (_data: { claimVideosPaged:PagedClaimPhotosType }) => {
    if (_data?.claimVideosPaged?.items?.length) {
      if (setVideosList) {
        const newItems = _data?.claimVideosPaged?.items;
        if (videosList && videosList?.length > 0 && !videosList?.some(p => p.ctfileId === newItems[0].ctfileId)) {
          const updatePhotos = [...videosList, ...newItems];
          setVideosList(updatePhotos);
        } else if (!videosList || videosList?.length === 0) {
          setVideosList(newItems);
        }
      }
      if (setTotalItems) {
        setTotalItems(_data?.claimVideosPaged?.totalItems);
      }
    }
    if (onSuccess) await onSuccess(_data, claimIndx);
  };

  const { data, isLoading, isFetching, refetch } = useBaseQuery(
    region,
    { claimIndx, currentPage, itemsPerPage },
    userState,
    enabled,
    GET_CLAIM_VIDEOS_LIST_PAGED,
    claimsKeys.claimPhotos(),
    DomainParams.Common,
    onSuccessPhotos,
  );

  const claimVideosList: ClaimPhotosType[] =
    !isLoading && !isFetching ? data?.claimVideosPaged?.items || [] : [];
  return { claimVideosList, isLoading, isFetching, refetch };
};

export default useClaimVideosPaged;